import { render, staticRenderFns } from "./addUniappVersion.vue?vue&type=template&id=6a473cdb&"
import script from "./addUniappVersion.vue?vue&type=script&lang=js&"
export * from "./addUniappVersion.vue?vue&type=script&lang=js&"
import style0 from "./addUniappVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports